export var Visibility;
(function (Visibility) {
    Visibility["ONE_PATIENT"] = "ONE_PATIENT";
    Visibility["ONE_THERAPIST"] = "ONE_THERAPIST";
    Visibility["ONE_OFFICE"] = "ONE_OFFICE";
    Visibility["PUBLIC"] = "PUBLIC";
})(Visibility || (Visibility = {}));
//# sourceMappingURL=visibility.enum.js.map